import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { parse } from "./utils/parse";
export var BrowserSymbol = /*#__PURE__*/ function() {
    "use strict";
    function BrowserSymbol(param) {
        var content = param.content;
        _class_call_check(this, BrowserSymbol);
        _define_property(this, "isMounted", false);
        _define_property(this, "node", void 0);
        this.node = parse(content);
    }
    _create_class(BrowserSymbol, [
        {
            key: "id",
            get: function get() {
                return this.node.id;
            }
        },
        {
            key: "mount",
            value: function mount(target) {
                if (this.isMounted) {
                    return this.node;
                }
                this.isMounted = true;
                target.appendChild(this.node);
                return this.node;
            }
        },
        {
            key: "unmount",
            value: function unmount() {
                if (this.node && this.node.parentNode) {
                    this.node.parentNode.removeChild(this.node);
                    this.isMounted = false;
                }
            }
        }
    ], [
        {
            key: "createFromExistingNode",
            value: function createFromExistingNode(node) {
                var symbol = new BrowserSymbol({
                    content: ""
                });
                symbol.node = node;
                return symbol;
            }
        }
    ]);
    return BrowserSymbol;
}();

//# sourceMappingURL=browser-symbol.js.map